import { createModalExecutor } from '@organisms/actions/createModalExecutor';
import { IRemoveRouteMapProps } from './IRemoveRouteMapProps';
import { RemoveRouteMapModal } from './RemoveRouteMapModal';

export const RemoveRouteMapExecutor = createModalExecutor<IRemoveRouteMapProps>({
    modal: RemoveRouteMapModal,
    defaultModalSize: 'l',
    mapProps: ({ action, modalSize, completeHandler }) => ({
        actionKey: action.key,
        activityKey: action.options?.activityKey,
        processKey: action.options?.processKey,
        documentKey: action.options?.documentKey,
        modalSize,
        completeHandler,
    }),
});
